var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewinquirylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_17116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.418 18.3125C14.418 17.2351 14.846 16.2017 15.6078 15.4399C16.3697 14.678 17.403 14.25 18.4805 14.25L29.8555 14.25C30.9329 14.25 31.9662 14.678 32.7281 15.4399C33.49 16.2017 33.918 17.2351 33.918 18.3125L33.918 24L28.2305 24C27.153 24 26.1197 24.428 25.3578 25.1899C24.596 25.9517 24.168 26.9851 24.168 28.0625L24.168 33.75L18.4805 33.75C17.403 33.75 16.3697 33.322 15.6078 32.5601C14.846 31.7983 14.418 30.7649 14.418 29.6875L14.418 18.3125ZM25.793 33.5209C26.3677 33.3193 26.8897 32.9911 27.3205 32.5605L32.7285 27.1509C33.1583 26.7204 33.4859 26.199 33.6872 25.625L28.2305 25.625C27.584 25.625 26.964 25.8818 26.5069 26.3389C26.0498 26.796 25.793 27.416 25.793 28.0625L25.793 33.5209Z",
    fill: "#6D5FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_17116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.0269 11.9731) rotate(0.127499)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewinquirylogo);
export default __webpack_public_path__ + "static/media/newinquirylogo.311be16815c0b863b0b30763a0dd1462.svg";
export { ForwardRef as ReactComponent };